<template>
    <div>
        <sau-service-status :service="service"></sau-service-status>

        <template v-if="service.fields">

            <h3 class="mt-6">Service Details</h3>
            <div class="row pb-6">
                <div class="col">
                    <div class="sau-bx bx-pad">

                        <div class="row mb-6">
                            <div class="col-12">
                                <h5>Data Centre: <span class="text-primary">{{ service.fields['Data Center'] }}</span></h5>
                                <template v-for="key in filteredKeys">
                                    <h5 v-if="service.fields[key]" :key="key">{{ key }}: <span class="text-primary">{{ service.fields[key] }}</span></h5>
                                </template>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 text-center">
                                <p class="sau-font-bold mb-0">A Side</p>
                                <p class="mb-0">{{ service.fields['A Side'] }}</p>
                                <i class="fas fa-exchange-alt fa-rotate-90 my-4"></i>
                                <p class="sau-font-bold mb-0">Z side</p>
                                <p class="mb-0">{{ service.fields['Z Side'] }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </template>

    </div>

</template>

<script>

export default {
    props: ['service'],
    data() {
        return {
            reservedKeys: [
                'A Side',
                'Z Side',
                'Full Path',
                'Data Center'
            ]
        };
    },
    computed: {
        filteredKeys() {
            const fields = _.get(this, 'service.fields', {});
            return Object.keys(fields).filter((key) => !this.reservedKeys.includes(key));
        }
    },
    created() {
        // Lock down functionality if the service is suspended
        if (this.service.status.toLowerCase() != 'suspended') {
        }
    },
}
</script>
<style scoped>
    i {
        background-color:#0769ba;
        color:white;
        padding:10px;
        border-radius:25px;
    }
</style>
